import { FC, PropsWithChildren } from "react";
const COLUMN_STYLES_MAPPING = {
  2: "flex flex-col gap-4 sm:grid sm:grid-cols-2",
  3: "flex flex-col gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-3",
  4: "flex flex-col gap-4 sm:grid sm:grid-cols-3 lg:grid-cols-4",
};
type GridProps = {
  numberOfColumns?: keyof typeof COLUMN_STYLES_MAPPING;
};
export const Grid: FC<PropsWithChildren<GridProps>> = ({
  children,
  numberOfColumns = 4,
}) => <div className={COLUMN_STYLES_MAPPING[numberOfColumns]}>{children}</div>;
